import { useSearchInvoiceReportsHook } from 'ap-openapi';
import { useCallback } from 'react';

export const useCheckInvoiceReportPermission = () => {
  const searchInvoiceReports = useSearchInvoiceReportsHook();

  return useCallback(async () => {
    const response = await searchInvoiceReports({
      pagination: { per_page: 1, page: 1 },
    });
    return { data: { status: response.status } };
  }, [searchInvoiceReports]);
};
